import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const OneImageComponent = () => {
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  
  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth >= 900);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);
  
  const text = [
  "Asociatia PsiNapsis a organizat recent evenimentul 'Construind legaturi intre nevoie si solutii', o serie de workshopuri si ateliere dedicate specialistilor din domeniul terapiei de recuperare. Evenimentul a avut loc în perioada 22-24 august, la Chalet Transylvania, Orlat - Sibiu si a reprezentat un pas important in crearea unor contexte de invatare si reflectie pentru comunitatea profesionala.",
  "Am creat un spatiu in care dialogul autentic si colaborarea interdisciplinara au primat, oferind participantilor o experienta completa, intr-un cadru primitor si conectat cu natura.",
  "Toate costurile au fost acoperite integral de Asociația PsiNapsis."
];
  
  const images = [
    {
      id: 1,
      src: "/images/echipa full.jpg",
      alt: "Eveniment imagine 1"
    },
  ];
  
  const openFullscreen = (image) => {
    setFullscreenImage(image);
  };
  
  const closeFullscreen = () => {
    setFullscreenImage(null);
  };
  
  return (
    <div style={{ width: '100%', maxWidth: '1200px', margin: '0 auto', padding: '16px' }}>
      {/* Layout principal */}
      <div style={{ 
        display: 'flex', 
        flexDirection: isLargeScreen ? 'row' : 'column',
        alignItems: 'flex-start'
      }}>
        {/* Text - stanga pe ecrane mari */}
      <div style={{ 
        flex: 'grow: 3',
        minWidth: '0',
        paddingLeft: '20px',
        paddingRight: '15px'
      }}>
  
      {text.map((paragraph, index) => (
        <p 
          key={index} 
          style={{ 
          color: 'black',
          lineHeight: '1.7',
          fontSize: '16px',
          textAlign: 'justify',
          margin: '0 0 16px 0' 
      }}>
      {paragraph}
        </p>
    ))}
    </div>

        
        {/* Imagini - dreapta pe ecrane mari, jos pe ecrane mici/medii */}
        <div style={{ 
          flex: 'grow: 1',
          width: '100%'
        }}>
          <div style={{ 
            display: 'flex',
            width: '100%',
          }}>
            {images.map((image) => (
              <div
                key={image.id}
                onClick={() => openFullscreen(image)}
                style={{
                  flex: 'grow',
                  height: isLargeScreen ? '240px' : '320px',
                  cursor: 'pointer',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  transition: 'transform 0.3s ease',
                  margin: 'auto'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block',
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Modal pentru fullscreen */}
      {fullscreenImage && (
        <div 
          onClick={closeFullscreen}
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            zIndex: '9999',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px'
          }}
        >
          <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <button
              onClick={closeFullscreen}
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                zIndex: '10',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                border: 'none',
                borderRadius: '50%',
                padding: '8px',
                cursor: 'pointer',
                color: 'white'
              }}
            >
              <X size={24} />
            </button>
            <img
              src={fullscreenImage.src}
              alt={fullscreenImage.alt}
              onClick={(e) => e.stopPropagation()}
              style={{
                maxWidth: '90vw',
                maxHeight: '90vh',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
                borderRadius: '8px'
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default OneImageComponent;